import React, { useState, useEffect, Fragment } from "react";
import contactImg from "../../images/newHome/contact.png"
import FormInput from "./FormInput";
import ThemeButton from "./ThemeButton";
import SectionTitle from "./SectionTitle";

function ContactSection() {
    return (
        <Fragment>
            <div className="container lg:max-w-none container lg:max-w-none lg:px-0 lg:mx-0 lg:pb-20 pb-5">
                {/* container */}
                <div className="grid grid-cols-1 lg:grid-cols-2">
                    <div className="hidden lg:block">
                        <img className="w-full max-h-[960px] object-cover" src={contactImg} alt={contactImg} />
                    </div>
                    <div className="flex items-center justify-center mt-5 lg:mt-[unset]">
                        <div className="md:w-[480px]">
                            <SectionTitle
                                size="font-inter md:text-[44px] text-[32px]"
                                weight="font-bold"
                                color="text-titleColor"
                                align = "text-start"
                            >
                                Contact us
                            </SectionTitle>
                            <p className="lg:text-lg text-base text-gray-400 mt-6">Our friendly team would love to hear from you.</p>

                            {/* form section */}

                            <form className="max-w-xl mx-auto space-y-6 lg:mt-12 mt-5">
                                <div className="grid grid-cols-2 gap-8">
                                    <FormInput label="First name" name="firstName" placeholder="First name" />
                                    <FormInput label="Last name" name="lastName" placeholder="Last name" />
                                </div>
                                <FormInput label="Email" type="email" name="email" placeholder="you@company.com" />

                                <FormInput
                                    type="tel"
                                    label="Phone number"
                                    placeholder="+1 (555) 000-0000"
                                    name="phone"
                                    options={[{ label: "US" }, { label: "UK" }, { label: "IN" }]} />

                                <FormInput
                                    type="textarea"
                                    label="Message"
                                    name="message"
                                    placeholder="Leave us a message..."
                                    rows={5}
                                />

                                <FormInput
                                    type="checkbox"
                                    checkboxLabel="You agree to our friendly"
                                />
                                <div>
                                    <ThemeButton
                                        type = "submit"
                                        bgColor="bg-primaryColor"
                                        textColor="text-white"
                                        padding="w-full py-4"
                                        size="text-lg"
                                        className="font-semibold"
                                    >
                                        Submit
                                    </ThemeButton>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )

}
export default ContactSection;